"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, n, r, a, o, c) {
  try {
    var u = e[o](c),
      i = u.value;
  } catch (e) {
    return void n(e);
  }
  u.done ? t(i) : Promise.resolve(i).then(r, a);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, a) {
      var o = e.apply(t, n);
      function c(e) {
        asyncGeneratorStep(o, r, a, c, u, "next", e);
      }
      function u(e) {
        asyncGeneratorStep(o, r, a, c, u, "throw", e);
      }
      c(void 0);
    });
  };
}
var CLASS_NAME = "Leads:",
  BUBBLE_API_HOST2 = "https://api2.getmybubble.io";
function getStrFromJson(e) {
  var t,
    n = require("./Utility.module").getKeyMapOrder4Mapping();
  return t = [], n.forEach(function (n, r) {
    e[n] && t.push("".concat(r, "=").concat(e[n]));
  }), t.join("&");
}
function getLeadsByDateLocal(e) {
  return _getLeadsByDateLocal.apply(this, arguments);
}
function _getLeadsByDateLocal() {
  return (_getLeadsByDateLocal = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var n, r, a;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return n = ":getLeadsByDate:", r = new AWS.Lambda(), console.log("Entered:Input: id:", t, n, CLASS_NAME), a = {
            FunctionName: ESTIMATOR_WHATIFS_API2_LAMBDA,
            InvocationType: "RequestResponse",
            LogType: "Tail",
            Payload: '{ "fun": "getLeadsByDate", "fetchViaAPI": "false", "input": '.concat(t, "}")
          }, console.log("Before invoke WhatIfScenarioLambdaV2.getLeadsByDate -------\x3e : id:", t, n, CLASS_NAME), e.next = 7, r.invoke(a).promise();
        case 7:
          return e.abrupt("return", e.sent);
        case 8:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
function createIdMappingLocal(e) {
  return _createIdMappingLocal.apply(this, arguments);
}
function _createIdMappingLocal() {
  return (_createIdMappingLocal = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var n, r, a, o;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return ":createIdMapping:", console.log("Entered:Input: inputJson:", t, ":createIdMapping:", CLASS_NAME), n = getStrFromJson(t), r = "1141197152177214164206220136146145184149188205158214", t.fun && (r = t.fun), a = "".concat(BUBBLE_API_HOST2, "/fetch1?fun=").concat(r, "&").concat(n), console.log("url: ", a), o = require("axios"), e.abrupt("return", o.get(a));
        case 9:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
exports.getLeadsByDate = function (e) {
  return getLeadsByDateLocal(e);
}, exports.createIdMapping = function () {
  var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return e.abrupt("return", createIdMappingLocal(t));
        case 1:
        case "end":
          return e.stop();
      }
    }, e);
  }));
  return function (t) {
    return e.apply(this, arguments);
  };
}();